/**
 * /evaluations — sessions ↔ requests ↔ trace spans (read-only).
 */

import { useLoaderData } from "react-router-dom";

import { PageHeader } from "@/components/page-header";
import { ActivityBrowser } from "@/features/activity/activity-browser";
import { api } from "@/lib/api";
import type { ActivityListEnvelope, ActivitySession, AgentListResponse } from "@/lib/types";

interface EvaluationsLoaderData {
  sessions: ActivitySession[];
  agents: { id: string; name: string }[];
}

export async function evaluationsLoader(): Promise<EvaluationsLoaderData> {
  const [sessionsBody, agentsBody] = await Promise.all([
    api<ActivityListEnvelope<ActivitySession>>("/activity/sessions?limit=100"),
    api<AgentListResponse>("/agents?limit=200"),
  ]);
  return {
    sessions: sessionsBody.data ?? [],
    agents: agentsBody.items.map((a) => ({ id: a.id, name: a.name })),
  };
}

export default function EvaluationsRoute() {
  const data = useLoaderData() as EvaluationsLoaderData;
  return (
    <section className="space-y-4">
      <PageHeader
        eyebrow="workspace"
        title="Activity"
        subtitle="Every agent run in this team — sessions, the requests inside each session, and the trace spans behind each request. The same data eval and optimization read from."
      />
      <ActivityBrowser initial={data} />
    </section>
  );
}
